import { Select, DatePicker } from "antd";
import SearchInput from "pages/data-table-view/components/SearchInput";

const { RangePicker } = DatePicker;

const STATUS_OPTIONS = [
  { value: "completed", label: "Completed" },
  { value: "refunded", label: "Refunded" },
  { value: "partially_refunded", label: "Partially Refunded" },
  { value: "failed", label: "Failed" },
];

const SALE_TYPE_OPTIONS = [
  { value: "one_time", label: "One Time" },
  { value: "subscription", label: "Subscription" },
  { value: "refund", label: "Refund" },
];

const SOURCE_OPTIONS = [
  { value: "manual", label: "Manual" },
  { value: "stripe_webhook", label: "Stripe Webhook" },
  { value: "stripe_import", label: "Stripe Import" },
];

const ITEMS_PER_PAGE_OPTIONS = [
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "500", value: 500 },
  { label: "1000", value: 1000 },
];

export default function SalesFilters({
  filters,
  search,
  onFiltersChange,
  onSearchChange,
  addButton,
  exportButton,
  itemsPerPage,
  onItemsPerPageChange,
}) {
  const handleFilterChange = (key, value) => {
    if (key === "dateRangeType" && value !== "custom") {
      onFiltersChange({ ...filters, dateRangeType: value, customDateRange: null });
      return;
    }
    onFiltersChange({ ...filters, [key]: value });
  };

  const handleSearchFieldChange = (key) => (e) => {
    onSearchChange({ ...search, [key]: e.target.value });
  };

  const handleSearchFieldClear = (key) => () => {
    onSearchChange({ ...search, [key]: "" });
  };

  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <SearchInput
          value={search.productName}
          onChange={handleSearchFieldChange("productName")}
          onClear={handleSearchFieldClear("productName")}
          placeholder="Product Name"
        />
        <SearchInput
          value={search.stripeCustomerId}
          onChange={handleSearchFieldChange("stripeCustomerId")}
          onClear={handleSearchFieldClear("stripeCustomerId")}
          placeholder="Stripe Customer ID"
        />
        <SearchInput
          value={search.stripePaymentIntentId}
          onChange={handleSearchFieldChange("stripePaymentIntentId")}
          onClear={handleSearchFieldClear("stripePaymentIntentId")}
          placeholder="Stripe Payment Intent ID"
        />
        <SearchInput
          value={search.utmSource}
          onChange={handleSearchFieldChange("utmSource")}
          onClear={handleSearchFieldClear("utmSource")}
          placeholder="UTM Source"
        />
      </div>

      <div className="flex flex-wrap items-center gap-3 w-full">
        <Select
          value={filters.dateRangeType}
          onChange={(val) => handleFilterChange("dateRangeType", val)}
          style={{ width: 150 }}
        >
          <Select.Option value="today">Today</Select.Option>
          <Select.Option value="yesterday">Yesterday</Select.Option>
          <Select.Option value="thisWeek">This Week</Select.Option>
          <Select.Option value="thisMonth">This Month</Select.Option>
          <Select.Option value="lastMonth">Last Month</Select.Option>
          <Select.Option value="thisYear">This Year</Select.Option>
          <Select.Option value="allTime">All Time</Select.Option>
          <Select.Option value="custom">Custom Range</Select.Option>
        </Select>

        {filters.dateRangeType === "custom" && (
          <RangePicker
            format="YYYY-MM-DD"
            value={filters.customDateRange}
            onChange={(dates) => {
              if (dates && dates.length === 2) {
                handleFilterChange("customDateRange", dates);
              }
            }}
          />
        )}

        <Select
          allowClear
          placeholder="Status"
          value={filters.status}
          onChange={(val) => handleFilterChange("status", val)}
          style={{ width: 170 }}
          options={STATUS_OPTIONS}
        />

        <Select
          allowClear
          placeholder="Sale Type"
          value={filters.saleType}
          onChange={(val) => handleFilterChange("saleType", val)}
          style={{ width: 150 }}
          options={SALE_TYPE_OPTIONS}
        />

        <Select
          allowClear
          placeholder="Source"
          value={filters.source}
          onChange={(val) => handleFilterChange("source", val)}
          style={{ width: 160 }}
          options={SOURCE_OPTIONS}
        />

        {addButton}
        {exportButton}

        <div className="flex items-center gap-2 ml-auto flex-shrink-0">
          <span className="text-sm text-gray-500">Show:</span>
          <Select
            className="!w-[70px]"
            onChange={onItemsPerPageChange}
            value={itemsPerPage}
            options={ITEMS_PER_PAGE_OPTIONS}
          />
        </div>
      </div>
    </div>
  );
}
